<template>
  <v-timeline-item :color="formattedChange.iconInfo.color" fill-dot>
    <template #icon>
      <activity-log-item-icon :icon-info="formattedChange.iconInfo" />
    </template>

    <v-row class="pt-2">
      <v-col class="grow">
        <vs-text>
          <b>{{ formattedChange.type }}</b> {{ formattedChange.modifiedBy }}
        </vs-text>
      </v-col>
      <v-col class="shrink">
        <vs-text>{{ formattedChange.modifiedDisplay }}</vs-text>
      </v-col>
    </v-row>

    <vs-text v-for="field in formattedChange.importantFields" :key="fieldKey(field)" type="caption">
      <span v-if="field.prefix">{{ field.prefix }}{{ field.originalValue ? ': ' : '' }}</span>
      <s v-if="field.strikeLeft" class="original-value">{{ field.originalValue }}</s>
      <span v-else>{{ field.originalValue }}</span>
      <span v-if="field.newValue">
        {{ field.isArraySummary ? ': ' : ' → ' }}{{ field.newValue }}
      </span>
    </vs-text>

    <vs-text v-if="formattedChange.secondaryFields" type="caption">
      <span>{{ formattedChange.secondaryFields }}</span>
    </vs-text>
  </v-timeline-item>
</template>

<script setup lang="ts">
import ActivityLogItemIcon from './ActivityLogItemIcon.vue'

defineProps<{
  formattedChange: any
}>()

const fieldKey = (field) => `${field.columnName}-${field.originalValue}-${field.newValue}`
</script>

<style scoped>
.original-value {
  color: var(--color-grey--lighter);
}
</style>
